/* eslint-disable import/prefer-default-export */
export const hasDaxExternalSystem = (orderExternalSystem: string | undefined) =>
  orderExternalSystem === 'DAX';
